import { apiClient } from './client'
import type { ApiResponse } from '@/types/api'
import type { GameLessonPathGame } from './games'

// ── Types ────────────────────────────────────────────────────────────

export interface QuetureInfoResponse {
  quetureId: string
  title: string | null
  queturePoint: string | null
  hlsUrl: string | null
  summaryHlsUrl: string | null
  thumbnailUrl: string | null
  duration: number | null
  hasSummary: boolean
  pauseAndGos: Array<{
    id: number
    time: number
    type: string
    published: boolean
    whenToGo: number | null
    whenToGoBack: number | null
    bundleItem: string | null
    okButtonMessage: string | null
    notOkButtonMessage: string | null
    msg: string | null
    pauseDuration: number | null
    quizId: string | null
    videoKey: string | null
    isBlockQuiz: boolean
  }>
}

export interface QuetureContentResponse {
  quetureId: string
  qnIntro?: Array<{ text?: string; imageUrl?: string; audioUrl?: string }>
  qnOutro?: Array<{
    text?: string; imageUrl?: string; audioUrl?: string
    answer0?: string; answer1?: string; correctAnswer?: string
  }>
  queboardConfig?: Array<{ problem: any; features: any; tutorial: any; character?: string }>
  buildup?: Array<{
    step: string
    title: string
    items: Array<{
      number: number
      title?: string
      problem?: string
      options?: string
      answer?: string
      desc?: string
      answerCriteria?: string
      teacherCheck?: string
      probImageUrls?: string[]
      descImageUrls?: string[]
      probPrintImageUrls?: string[]
      descPrintImageUrls?: string[]
    }>
  }>
  essentialCheck?: Array<Record<string, unknown>>
  warmupText?: string | null
  shortPoint?: string | null
}

// ── API ──────────────────────────────────────────────────────────────

export const contentInspectionApi = {
  getQuetureInfo: async (
    contentId: number,
    quetureId: string,
    includeUnpublishedPauseAndGo = true
  ): Promise<QuetureInfoResponse> => {
    const response = await apiClient.get<ApiResponse<QuetureInfoResponse>>(
      `/content/${contentId}/quetures/${quetureId}`,
      { params: includeUnpublishedPauseAndGo ? { includeUnpublishedPauseAndGo: true } : undefined }
    )
    return response.data.data!
  },

  getQuetureContent: async (quetureId: string): Promise<QuetureContentResponse> => {
    const response = await apiClient.get<ApiResponse<QuetureContentResponse>>(
      `/content/queture-contents/${quetureId}`
    )
    return response.data.data ?? { quetureId }
  },

  getGamesByLessonPath: async (
    curriculumContentId: number,
    courseContentId: number,
    moduleContentId: number,
    lessonContentId: number
  ): Promise<GameLessonPathGame[]> => {
    const response = await apiClient.get<ApiResponse<GameLessonPathGame[]>>(
      '/admin/games/by-lesson-path',
      {
        params: {
          curriculumContentId,
          courseContentId,
          moduleContentId,
          lessonContentId,
        },
      }
    )
    return response.data.data ?? []
  },
}
